import getIn from './getIn'

const getValue = (form, key, defaultVal = '') => {
  if (!form) return defaultVal
  const v = getIn(form, `values.${key}`)
  return v !== undefined ? v : defaultVal
}

export default getValue
